import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApiConfig } from "@shared/models/redux";
import { UserRole } from "@myProfile/models";

/**
 * Fetches user roles from contact-service. Identity-aware: server derives the target
 * contact from the caller's JWT (and entitledUserId for impersonation) via
 * entitlement-service's IdentityController.
 *
 * API: GET contacts/v1/user/Roles[?entitledUserId={id}]
 * Response: UserRole[] e.g. [{ roleName: "Primary Contact" }, { roleName: "Tax Advisor" }]
 */
export const fetchUserRolesThunk = createAsyncThunk<UserRole[], void, ThunkApiConfig>(
  "myProfile/fetchUserRoles",
  async (_, { extra, rejectWithValue }) => {
    try {
      const response = await extra<UserRole[]>("contacts/v1/user/Roles", { method: "GET" });

      return response.data;
    } catch (error) {
      console.error("[fetchUserRoles] Error fetching user roles:", error);

      return rejectWithValue("Failed to fetch user roles");
    }
  }
);
